export const STATUS_STYLE = {
  SAFE: { color: "#10B981", label: "Sécurisé", badge: "bg-emerald-500", text: "text-emerald-600", ring: "ring-emerald-500" },
  VALIDATION: { color: "#F59E0B", label: "À valider", badge: "bg-amber-500", text: "text-amber-600", ring: "ring-amber-500" },
  VIOLATION: { color: "#EF4444", label: "Violation", badge: "bg-red-500", text: "text-red-600", ring: "ring-red-500" },
  NORMAL: { color: "#3B82F6", label: "Normal", badge: "bg-blue-500", text: "text-blue-600", ring: "ring-blue-500" },
  UNKNOWN: { color: "#94A3B8", label: "Non analysé", badge: "bg-slate-400", text: "text-slate-500", ring: "ring-slate-400" },
};

export function stopStyle(s) {
  return STATUS_STYLE[s?.safety_status] || STATUS_STYLE.UNKNOWN;
}

export const ROUTE_STATUS_LABEL = {
  DRAFT: "Brouillon", IMPORTED: "Importée", GEOCODED: "Géocodée", ANALYZED: "Analysée",
  OPTIMIZED: "Optimisée", DISPATCH_REVIEW: "En révision", APPROVED: "Approuvée",
  PUBLISHED: "Publiée", ASSIGNED: "Assignée",
};

export function fmtDuration(min) {
  if (min == null) return "—";
  const h = Math.floor(min / 60);
  const m = Math.round(min % 60);
  return h > 0 ? `${h} h ${String(m).padStart(2, "0")}` : `${m} min`;
}
